import { createBrowserRouter } from 'react-router-dom';

import { adminRoutes } from './routes/adminRoutes';
import { learnerRoutes } from './routes/learnerRoutes';
import { publicRoutes } from './routes/publicRoutes';

export const routerRoutes = [...publicRoutes, ...learnerRoutes, ...adminRoutes];

export const appRouter = createBrowserRouter(routerRoutes);
